import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FleetBoardModalComponent } from 'src/app/components/profile/fleet-board-modal/fleet-board-modal.component';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-fleet-grok-page',
  templateUrl: './user-profile-fleet-grok-page.component.html',
  styleUrls: ['./user-profile-fleet-grok-page.component.scss'],
})
export class UserProfileFleetGrokPageComponent implements OnInit {
  pageSize = 10000;
  isPopupVisible = false;

  constructor(
    private dialog: MatDialog,
    private message: MessageService,
    private apiUser: UserApiService
  ) {
  }

  ngOnInit(): void {
    this.getSeat();
    this.checkAnnouncementStatus();
  }

  seat: any;
  async getSeat() {
    try {
      this.loading = true;
      const r = await this.apiUser.getGrokCount('Active', '');
      this.seat = r.data;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
      this.getFleetAuthTokens();
    }
  }

  calculatePercent(remain: any, times: any): number {
    const remainValue = Number(remain);
    const timesValue = Number(times);
    return timesValue ? (remainValue / timesValue) * 100 : 0;
  }

  visit() {}

  openBoard() {
    this.dialog.open(FleetBoardModalComponent, {});
  }

  async checkAnnouncementStatus() {
    try {
      const r = await this.apiUser.checkAnnouncementStatus();
      const status = r.data[0].is_computer;
      if (!status) {
        this.openBoard();
      }
    } catch (error) {}
  }

  explain() {
    this.isPopupVisible = !this.isPopupVisible;
  }

  cards: any[] = [];
  loading = false;
  findFleetCards = async () => {
    try {
      const r = await this.apiUser.findFleetCardsGrok(1, this.pageSize);
      const list = r.data.data.list || [];
      this.cards = list;
    } catch (error) {
      this.message.open('网络错误');
    }
  };

  tokens: any;
  async getFleetAuthTokens() {
    try {
      this.loading = true;
      const r = await this.apiUser.getFleetGrokAuthTokens();
      this.tokens = r.data;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  format = (item: any) => (): string => {
    return `${item}`;
  };
}
